<footer class="c-footer">
	<div class="wrapper">
		<div class="container-fluid container-mw">
			<div class="row block-main">
				<div class="col-xs-12 col-sm-6 main-left">
					<div class="maintain-header">
						<span class="text-footer-14 op-64">Maintained by</span>
						<a class="text-footer-14" href="/about#people">jsDelivr team and contributors</a>
						<br>
						<span class="text-footer-14 op-64">Founded by</span>
						<a class="text-footer-14" target="_blank" rel="noopener noreferrer"
							href="https://dakulov.com/">Dmitriy Akulov</a>
					</div>
				</div>

				<div class="col-xs-12 col-sm-6 main-right">
					<div class="main-right-container">
						<div class="subscribe-header">
							<span class="text-footer-14">Sign up to our newsletter</span>
						</div>
						<form class="form-inline subscribe-content"
							action="https://jsdelivr.us11.list-manage.com/subscribe?u=0c85fe2c9a60310df9a3d6751&id=283887f736"
							method="POST" target="_blank">
							<div class="form-group">
								<input type="email" autocomplete="email" class="form-control" name="MERGE0" id="new-email" placeholder="Enter your e-mail">
							</div>
							<button type="submit" class="btn btn-default semi-bold">Subscribe</button>
						</form>
					</div>
				</div>
			</div>

			<div class="footer-separator"></div>

			<div class="block-list">
				<div class="title-copy-bottom op-64">&copy; jsdelivr.com, 2012 - {{date.getFullYear()}}</div>

				<div class="row list-primary">
					<div class="col-sm-12">
						<div class="title-copy op-64">&copy; jsdelivr.com, 2012 - {{date.getFullYear()}}</div>
						<ul>
							<li> <a href="/about"> About </a> </li>
							<li> <a href="/history"> Our History </a> </li>
							<li> <a href="/sponsors"> Our Sponsors </a> </li>
							<li> <a href="/oss-cdn"> Custom OSS CDN </a> </li>
							<li> <a href="https://status.jsdelivr.com/"> Status </a> </li>
							<li> <a href="/terms"> Terms &amp; Policies </a> </li>
							<li> <a href="mailto:d@jsdelivr.com"> d@jsdelivr.com </a> </li>
						</ul>
					</div>
				</div>

				<div class="row list-second">
					<div class="col-sm-12">
						<div class="title-convert op-64">Convert from:</div>
						<ul>
							<li><a href="/github">GitHub</a></li>
							<li><a href="/google">Google Hosted Libraries</a></li>
							<li><a href="/unpkg">unpkg</a></li>
							<li><a href="/skypack">Skypack</a></li>
							<li><a href="/esmsh">esm.sh</a></li>
						</ul>
					</div>
				</div>
			</div>

			<div class="footer-separator"></div>

			<div class="footer-blog-links">
				<div class="footer-blog-links_title op-64">From our Blog</div>

				<div class="footer-blog-links_block">
					{{#each blogLinksData}}
						<a class="router-ignore" target="_blank" href="{{@shared.serverHost}}{{this.url}}">{{this.text}}</a>
					{{/each}}
				</div>
			</div>
		</div>
	</div>
</footer>

<script>
	const http = require('../../assets/js/utils/http');

	component.exports = {
		data () {
			return {
				date: new Date(),
				docInnerHtml: null,
				blogLinksData: null,
			};
		},
		oninit () {
			if (!Ractive.isServer) {
				http.getBlogRss().then((response) => {
					if (response) {
						let document = new window.DOMParser().parseFromString(response, 'text/xml');
						let items = document.documentElement.childNodes[0].getElementsByTagName('item');
						let data = [];

						for (let i = 0; i < items.length; i++) {
							let currItemNodesList = items[i].childNodes;
							let currItemTitle;
							let currItemLink;
							let currItemPubDate;

							for (let k = 0; k < currItemNodesList.length; k++) {
								if (currItemNodesList[k].nodeName === 'title') {
									currItemTitle = currItemNodesList[k].textContent;
								} else if (currItemNodesList[k].nodeName === 'link') {
									currItemLink = currItemNodesList[k].textContent;
								} else if (currItemNodesList[k].nodeName === 'pubDate') {
									currItemPubDate = currItemNodesList[k].textContent;
								}
							}

							data.push({
								text: currItemTitle,
								url: `/blog${new URL(currItemLink, 'https://www.jsdelivr.com').pathname}`,
								date: new Date(currItemPubDate).getTime(),
							});
						}

						data.sort((a, b) => b.date - a.date);

						this.set('blogLinksData', data.slice(0, 5));
					}
				});
			}
		},
	};
</script>
